export const API_ERROR_CAUSE_REASON = {
  mfaPasscodeInvalid: 'MFA_PASSCODE_INVALID',
  otpAccountLocked: 'OTP_ACCOUNT_LOCKED',
  otpResendRateLimited: 'OTP_RESEND_RATE_LIMITED',
  otpWrongCode: 'OTP_WRONG_CODE',
  resetTokenInvalid: 'RESET_TOKEN_INVALID',
} as const;
